export default __webpack_public_path__ + "static/media/noah_profile_pic.88c36b9c.png";